import React from 'react';
import { useSelector } from 'react-redux';
import { selectAppSettings } from 'store/reducers/appSettings/appSettings.slice';
import { Box, Typography, List, ListItem } from '@mui/material';

const SaleshubInfo = () => {
  const { contact, contactMG, contactST } = useSelector(selectAppSettings);

  const items = [
    {
      type: 'list',
      heading: 'Questions:',
      elements: [
        <ListItem sx={styles.listItem} key={'questions-email'}>
          Email{' '}
          <strong>
            <a href="mailto:JH_eservice@jhancock.com">
              JH_eservice@jhancock.com
            </a>
          </strong>{' '}
          or
        </ListItem>,
        <ListItem sx={styles.listItem} key={'questions-number'}>
          Call {contact}.
        </ListItem>,
      ],
    },
    {
      type: 'line',
      element: <hr style={styles.line} key={'line'} />,
    },
    {
      type: 'list',
      heading: 'Allstate producers:',
      elements: [
        <List key={'producer-gateway-list'}>
          <ListItem sx={styles.listItem} key={'producer-gateway'}>
            Go to Allstate Gateway to login.
          </ListItem>
        </List>,
      ],
    },
    {
      type: 'list',
      heading: 'MGroup producers:',
      elements: [
        <ListItem sx={styles.listItem} key={'MGroup-number'}>
          {contactMG}.
        </ListItem>,
      ],
    },
    {
      type: 'list',
      heading: 'Simple Term producers:',
      elements: [
        <ListItem sx={styles.listItem} key={'SimpleTerm-number'}>
          {contactST}.
        </ListItem>,
      ],
    },
  ];
  return (
    <Box>
      <Typography sx={styles.heading}>
        Access and use of this website is for traditional life insurance
        producers.
      </Typography>
      {items.map((item) => {
        return item.type === 'list' ? (
          <Box sx={styles.mainBox} key={item.heading}>
            <Typography sx={styles.heading2}>{item.heading}</Typography>
            <List>{item.elements.map((el) => el)}</List>
          </Box>
        ) : (
          item.element
        );
      })}
      <Typography sx={styles.content}>
        Please note inactive sessions will close after 15 minutes and any
        unsaved data could be lost.
      </Typography>
      <Typography sx={styles.content}>
        For optimal viewing, we recommend using the latest version of Chrome,
        Edge, or Safari.
      </Typography>
    </Box>
  );
};

const styles = {
  heading: {
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000000',
    marginBottom: '16px',
    textAlign: 'left',
  },
  heading2: {
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000000',
    marginBottom: '0',
    textAlign: 'left',
  },
  email: {
    fontSize: '16px',
    color: '#282B3E',
    fontWeight: 600,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  line: {
    marginBottom: '20px',
  },
  content: {
    fontWeight: '400',
    textAlign: 'left',
    marginBottom: '20px',
    marginTop: '20px',
  },
  listItem: {
    padding: 0,
    textAlign: 'left',
    listStyleType: 'disc',
    display: 'list-item',
    marginBottom: '10px',
    lineHeight: '24px',
  },
};

export default SaleshubInfo;
